module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.b2ca57d4.png";